/* eslint-disable no-alert */
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col,
} from 'reactstrap';
import {
  Table, Thead, Tbody, Tr, Th, Td,
} from 'react-super-responsive-table';

import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';

import { get } from '../../helpers/api_helper';

function PicklistPrint(props) {
  const { t } = props;

  const { id } = useParams();
  const [picklist, setPicklist] = useState(null);
  const [summary, setSummary] = useState(null);

  const getSummary = (data) => {
    const sum = {};
    data.items.forEach((item) => {
      if (sum[item.order_item.inventory.stock_id]) {
        sum[item.order_item.inventory.stock_id].qty += item.order_item.qty;
      } else {
        sum[item.order_item.inventory.stock_id] = {
          qty: item.order_item.qty,
          description: item.order_item.inventory.ship_desc,
          part_number: item.order_item.inventory.part_number,
        };
      }
    });

    // sort by description, retain keys
    const sorted = {};
    Object.keys(sum).sort((a, b) => sum[a].description.localeCompare(sum[b].description))
      .forEach((key) => {
        sorted[key] = sum[key];
      });

    return sorted;
  };

  const fetchPicklist = async () => {
    try {
      const ent = await get(`/api/orders/picklist/${id}`);
      setPicklist(ent);
      setSummary(getSummary(ent));
    } catch (e) {
      setPicklist(null);
    }
  };

  useEffect(() => {
    // eslint-disable-next-line no-alert
    fetchPicklist();
  }, []);

  useEffect(() => {
    if (summary) window.print();
  }, [summary]);

  document.title = `Printable picklist #${id}`;

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col xl={12}>
            <h3>{t('Summary')}</h3>
            <Table
              className="table table-bordered"
            >
              <Thead>
                <Tr>
                  <Th>{t('Stock ID')}</Th>
                  <Th>{t('Description')}</Th>
                  <Th>{t('Qty')}</Th>
                </Tr>
              </Thead>
              <Tbody>
                {summary && Object.entries(summary).map(([stockId, data]) => (
                  <Tr key={stockId}>
                    <Td>{stockId}</Td>
                    <Td>{data.part_number}</Td>
                    <Td>{data.description}</Td>
                    <Td>{data.qty}</Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </Col>
        </Row>

        {/* page break */}
        <div style={{ pageBreakBefore: 'always' }} />

        <Row>
          <Col xl={12}>
            <h3>{t('Items')}</h3>
            <Table
              className="table table-bordered"
            >
              <Thead>
                <Tr>
                  <Th>{t('Pick Item ID')}</Th>
                  <Th>{t('Stock ID')}</Th>
                  <Th>{t('Part Number')}</Th>
                  <Th>{t('Order Ref')}</Th>
                  <Th>{t('Description')}</Th>
                </Tr>
              </Thead>
              <Tbody>
                {picklist && picklist.items.map((item) => (
                  <Tr key={item.id}>
                    <Td>{item.id}</Td>
                    <Td>{item.order_item.inventory.stock_id}</Td>
                    <Td>{item.order_item.inventory.part_number}</Td>
                    <Td>{item.order_reference}</Td>
                    <Td>{item.order_item.inventory.ship_desc}</Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </Col>
        </Row>
      </div>
    </div>
  );
}

PicklistPrint.defaultProps = {
  t: (x) => (x),
};

PicklistPrint.propTypes = {
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(PicklistPrint));
